module.exports = __webpack_public_path__ + "static/img/RE7.5ea757d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/RE7.jpg
// module id = Mm/p
// module chunks = 0